import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {EvidencesService} from "../../core/services/http/api/evidences.service";

@Component({
  selector: 'app-insert-code',
  templateUrl: './insert-code.component.html',
  styleUrls: ['./insert-code.component.scss', '../../../assets/audit/audit.scss']
})
export class InsertCodeComponent implements OnInit {

    public sending = false;
    public error = '';
    public form: FormGroup;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        private fb: FormBuilder,
        private evidencesService: EvidencesService
    ) {

    }

    ngOnInit(): void {


        this.form = this.fb.group({
            code: ['', [Validators.required, Validators.minLength(22), Validators.maxLength(22), Validators.pattern('[-a-zA-Z0-9]*')]]
        });

        if (typeof this.route.snapshot.queryParams['error'] !== 'undefined') {
            setTimeout(() => {
                switch (this.route.snapshot.queryParams['error']) {
                    case 404:
                        this.error = 'AUDIT.CODE.ERROR.404'
                        break;
                    default:
                        this.error = 'AUDIT.CODE.ERROR.500'
                        break;
                }
                this.router.navigate(['audit']).then();
            }, 20);

        }
    }

    checkCode() {
        if (this.form.valid) {
            this.sending = true;
            this.evidencesService.loginWithCode(this.form.get('code').value).subscribe((data: any) => {
                if (data.tkn) {
                    this.evidencesService.setJwt(data.tkn);
                    this.router.navigate(['audit/' + this.form.get('code').value]).then();
                }
            }, (err) => {
                if (err && err.status === 404) {
                    this.error = 'AUDIT.CODE.ERROR.404'
                } else {
                    this.error = 'AUDIT.CODE.ERROR.500'
                }

            }).add(() => this.sending = false);
        }

        // this.router.navigate(['audit/123456']).then();
    }

    inputCode(event) {
        console.log(event);
        this.error = '';
        this.form.get('code').patchValue(event.target.value.toUpperCase())
    }
}
